/**
 * @generated SignedSource<<9d00ffbc306b030b3aa355a78633908f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserGuildMembershipsEditorsSection_user$data = {
  readonly editingGuilds: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null | undefined;
      readonly node: {
        readonly guild: {
          readonly " $fragmentSpreads": FragmentRefs<"GuildCardNew_guild">;
        } | null | undefined;
      } | null | undefined;
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "UserGuildMembershipsEditorsSection_user";
};
export type UserGuildMembershipsEditorsSection_user$key = {
  readonly " $data"?: UserGuildMembershipsEditorsSection_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserGuildMembershipsEditorsSection_user">;
};

import UserGuildMembershipsEditorsSectionPaginationQuery_graphql from './UserGuildMembershipsEditorsSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "editingGuilds"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UserGuildMembershipsEditorsSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserGuildMembershipsEditorsSection_user",
  "selections": [
    {
      "alias": "editingGuilds",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "EDITOR"
          }
        }
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "__UserGuildMembershipsEditorsSection_user_editingGuilds_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildMembershipsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Guild",
                  "kind": "LinkedField",
                  "name": "guild",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "GuildCardNew_guild"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__UserGuildMembershipsEditorsSection_user_editingGuilds_connection(condition:{\"membershipLevel\":\"EDITOR\"})"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "fdf2084b0cfe0a713e7bb3b377fd3228";

export default node;
